// olap-client/src/components/HtmlMessage.jsx
import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const HtmlMessage = ({ text, isHtml }) => {
  const sanitizedHtml = useMemo(() => {
    if (!isHtml) return null;
    
    // Просто sanitize — без конвертаций
    return DOMPurify.sanitize(text, {
      ALLOWED_TAGS: [
        'b', 'strong', 'i', 'em', 'u', 's', 'strike',
        'br', 'p', 'div', 'span',
        'ul', 'ol', 'li',
        'a', 'code', 'pre', 'blockquote',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'table', 'thead', 'tbody', 'tr', 'th', 'td'
      ],
      ALLOWED_ATTR: ['href', 'title', 'target', 'style', 'class'],
      ADD_ATTR: ['target']
    });
  }, [text, isHtml]);

  if (!isHtml) {
    return (
      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {text}
      </div>
    );
  }

  return (
    <div 
      className="html-message"
      style={{ wordBreak: 'break-word', lineHeight: '1.5' }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default HtmlMessage;